module.exports = __webpack_public_path__ + "static/media/photo_reduced_4by5.85644c62.jpg";